export const PUSHE_TERMS_LINK = "https://pushe.co/terms/";
export const PUSHE_PRIVACY_LINK = "https://pushe.co/privacy/";
